export default {
    SENSITIVE_WORD_CODE: 31525,

    LANG: {
        ZH_CN: {
            code: 'zh-cn',
            shortname: '简',
        },
        ZH_TW: {
            code: 'zh-tw',
            shortname: '繁',
        },
        EN_US: {
            code: 'en-us',
            shortname: '英',
        },
    },

    wpaIconRoot: '/sites/srv/wpa/conf/wpa/v2/',
    wpaAvatarRoot: '/sites/srv/wpa/conf/wpa/avatar/',

    createUrl: '/v1/kf/reception/receptionConf/wechatSvr/wxWpaGroup/create',
    updateUrl: '/v1/kf/reception/receptionConf/wechatSvr/wxWpaGroup/update',
};
